import "./Branches.css";
import { useEffect, useState } from "react";
import { getBranchList } from "../../api/system.api";
import { useParams, useNavigate } from "react-router-dom";

export default function Branches() {
    const { systemId } = useParams();
    const navigate = useNavigate();
    const [branches, setBranches] = useState([]);

    useEffect(() => {
        getBranchList(systemId).then(res => {
            setBranches(res.data.branches || []);
        });
    }, [systemId]);

    const selectBranch = (branch) => {
        localStorage.setItem("branch_id", branch.id);
        navigate("/dashboard");
    };

    return (
        <div className="branches-page">
            <h2>Select Branch</h2>

            <div className="branches-grid">
                {branches.map(branch => (
                    <div
                        key={branch.id}
                        className="branch-card"
                        onClick={() => selectBranch(branch)}
                    >
                        <h3>{branch.name}</h3>
                        <span>{branch.system.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
